import { render, staticRenderFns } from "./registro-investigador.vue?vue&type=template&id=64001f94&scoped=true&"
import script from "./registro-investigador.component.ts?vue&type=script&lang=ts&"
export * from "./registro-investigador.component.ts?vue&type=script&lang=ts&"
import style0 from "./registro-investigador.vue?vue&type=style&index=0&id=64001f94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64001f94",
  null
  
)

export default component.exports